export default function Pagination({currentPage, totalPages, onPageChange}: {
    currentPage: number,
    totalPages: number,
    onPageChange: (page: number) => void
}) {
    const buildPageButton = (page: number) => {
        return (
            <button key={`pagination-${page}`}
                    className={"px-3 py-1 " + (currentPage === page ? "bg-primary-8" : "hover:bg-16 focus:bg-16")}
                    onClick={() => onPageChange(page)}
                    disabled={currentPage === page}>
                {page}
            </button>
        );
    }

    const buildPageButtons = () => {
        let buttons = [];

        if (currentPage > 1 && totalPages > 2) {
            buttons.push(buildPageButton(1));
            if (currentPage > 3) {
                if (currentPage > 4) {
                    buttons.push(<span key="pagination-ellipsis-left">...</span>);
                }
                buttons.push(buildPageButton(currentPage - 2));
            }
            if (currentPage > 2) {
                buttons.push(buildPageButton(currentPage - 1));
            }
        }

        buttons.push(buildPageButton(currentPage));

        if (currentPage <= totalPages - 1) {
            if (currentPage <= totalPages - 2) {
                buttons.push(buildPageButton(currentPage + 1));
            }
            if (currentPage <= totalPages - 3) {
                buttons.push(buildPageButton(currentPage + 2));
                if (currentPage <= totalPages - 4) {
                    buttons.push(<span key="pagination-ellipsis-right">...</span>);
                }
            }
            buttons.push(buildPageButton(totalPages));
        }

        return buttons;
    }

    return (
        <div className="pagination flex justify-center py-8">
            {buildPageButtons()}
        </div>
    );
}